export const handleSwiperTranslate = (e: any) => {
  if (!e || !e.slides.length) return

  const checkedProgress = checkProgress(e.progress)
  const l = e.slides.length > 0 ? e.slides.length : 1
  const length = 1 / (l - 1)

  const leftIndex = Math.floor(checkedProgress / length)
  const rightIndex = Math.ceil(checkedProgress / length)
  //TO DO middle chip index

  const leftSlide = e.slides[leftIndex]
  const rightSlide = e.slides[rightIndex]

  const leftChip = leftSlide.firstChild
  const rightChip = rightSlide.firstChild

  const leftScale = length - (checkedProgress % length)
  const rightScale = checkedProgress % length

  leftSlide.style.transform = `scale(${checkScale(1 + leftScale * 7)})`
  rightSlide.style.transform = `scale(${checkScale(1 + rightScale * 7)})`

  const leftRed = Math.floor(26 + 636 * leftScale * 7)
  const leftGreen = Math.floor(68 + 300 * leftScale * 7)
  const leftBlue = Math.floor(108 - 300 * leftScale * 7)

  const rightRed = Math.floor(26 + 636 * rightScale * 7)
  const rightGreen = Math.floor(68 + 300 * rightScale * 7)
  const rightBlue = Math.floor(108 - 300 * rightScale * 7)

  const blueToYellow = `rgb(${leftRed} , ${leftGreen}, ${leftBlue})`
  const YellowToBlue = `rgb(${rightRed} , ${rightGreen}, ${rightBlue})`

  leftChip.style.background = blueToYellow
  rightChip.style.background = YellowToBlue
  leftChip.firstChild.style.borderColor = YellowToBlue
  leftChip.style.borderColor = blueToYellow
  rightChip.firstChild.style.borderColor = blueToYellow
  rightChip.style.borderColor = YellowToBlue
  leftChip.firstChild.style.color = YellowToBlue
  rightChip.firstChild.style.color = blueToYellow
  for (let i = 0; i < e.slides.length; i++) {
    if (i !== leftIndex && i !== rightIndex) {
      // console.log("shemovida")
      // e.slides[i].firstChild.style.background = 'rgb(255, 176, 0)'
      e.slides[i].firstChild.style.background = `rgb(26, 68, 108)`
      e.slides[i].style.transform = `scale(1)`
      e.slides[i].firstChild.firstChild.style.borderColor = 'rgb(255, 176, 0)'
      e.slides[i].firstChild.style.borderColor = 'rgb(26, 68, 108)'
      e.slides[i].firstChild.firstChild.style.color = 'rgb(255, 176, 0)'
    }
  }
}

const checkScale = (scale: number) => {
  return scale >= 1.36 ? 1.36 : scale
}
const checkProgress = (progress: number) => {
  if (progress <= 0) {
    return 0
  } else if (progress >= 1) {
    return 1
  } else {
    return progress
  }
}
